import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

export function initSentry(): void {
    if (!dsn) {
        return;
    }

    Sentry.init({
        dsn,
        environment: import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined,
        release: import.meta.env.VITE_SENTRY_RELEASE as string | undefined,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        tracesSampleRate: 0.2,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
}

export function setSentryUser(user: {
    id: number;
    email: string;
    name: string;
} | null): void {
    if (!dsn) {
        return;
    }

    if (user) {
        Sentry.setUser({
            id: String(user.id),
            email: user.email,
            username: user.name,
        });
    } else {
        Sentry.setUser(null);
    }
}

export function setSentryTenant(tenant: {
    id: number | string;
    name: string;
} | null): void {
    if (!dsn) {
        return;
    }

    if (tenant) {
        Sentry.setTag('tenant.id', String(tenant.id));
        Sentry.setTag('tenant.name', tenant.name);
    } else {
        Sentry.setTag('tenant.id', undefined);
        Sentry.setTag('tenant.name', undefined);
    }
}

export { Sentry };
